import Crud from '../components/Video/Crud'
import Add from '../components/Video/Add'
import Edit from '../components/Video/Edit'

let routes = {
    path: '/video',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/video',
            component: Crud
        },
        {
            path: '/video/add',
            component: Add
        },
        {
            path: '/video/edit/:id',
            component: Edit
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/video.js